import { minesGameConnection } from '../minesConnection';
import { userInfoStore } from '../../../store/userInfoStore';
import { autoBetStore } from '../../../store/autoBetStore';
import { minesBetStore } from '../minesStore/betStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { ValidationType } from '../../../core/constants/validationType';
import {
  MAX_BOX_COUNT,
  MINES_FIELD_STATE,
  MinesBetStatus,
  MinesSoundsName,
} from '../minesCore/constants';
import { soundService } from '../../../services/baseSoundService/soundService';
import { DEFAULT_AUTO_BET_COUNT } from '../../../core/constants/autoBetContants';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { notificationStore } from '../../../store/notificationStore';
import { parseNumberByPrecision } from '../../../core/helpers/parseNumberByPrecision';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

let autoSelectTimeOutId;
let resetTimeOutId;
let isFirstMinesSound = true;

class MinesGameService {
  onGetInitialStateResult({ additionalInfo, spinInfo, odds: initialOdds }) {
    this.resetGameState();
    minesBetStore.resetStore();
    autoBetStore.resetAutoBetState();
    if (additionalInfo) {
      checkHashStore.setLastRoundInfo({
        key: additionalInfo.key,
        salt: additionalInfo.salt,
        hash: additionalInfo.hash,
      });
      checkHashStore.setLastRoundResult({
        mineFieldStates: additionalInfo.mineFieldStates,
        id: additionalInfo.id,
        bombCount: additionalInfo.bombCount,
      });
    }
    if (spinInfo) {
      const { spinData, odds, winAmount, odd, amount } = spinInfo;
      userInfoStore.setBetAmount(parseNumberByPrecision(1, +amount, userInfoStore.precision));
      const { mineFieldStates, bombCount } = spinData;
      minesBetStore.setMinesBox(mineFieldStates);
      minesBetStore.setCurrentActiveOdd(odd);
      minesBetStore.setOddsByBombCount(odds.map((el) => el.value));
      const oddsList = odds.map((filteredOdd) => filteredOdd.value);
      minesBetStore.setOdds(oddsList);
      const currentActiveOddIndex = odds.findIndex((item) => item.value === odd);
      const nextIndex = currentActiveOddIndex > -1 ? currentActiveOddIndex + 1 : 0;
      const nextOdd = odds[nextIndex]?.value || null;
      minesBetStore.setActiveOdd(nextOdd);
      minesBetStore.updateOddsForView(nextOdd, true);
      minesBetStore.setIsAllowCashOut(true);
      minesBetStore.setIsDoSpinStart(true);
      minesBetStore.setIsBetsClosed(true);
      minesBetStore.setCashOutWin(winAmount);
      minesBetStore.setMinesCount(bombCount, true);
      const openedDiamondCount = mineFieldStates.filter(
        (el) => el === MINES_FIELD_STATE.Diamond
      ).length;
      minesBetStore.setNonSelectedBoxIndex(mineFieldStates);
      minesBetStore.setIsAllowSendResultReport(true);
      minesBetStore.setDiamondsCount(MAX_BOX_COUNT - bombCount - openedDiamondCount);
    } else {
      minesBetStore.setOdds(initialOdds);
    }
  }

  doSpin() {
    if (!minesBetStore.isBetsClosed) {
      const model = {
        spinData: {
          bombCount: minesBetStore.minesCount,
          selectionCount:
            autoBetStore.isAutoBetOn &&
            freeBetStore.currentFreeBet &&
            minesBetStore.selectedFieldsIndex.length > 0
              ? minesBetStore.selectedFieldsIndex.length
              : null,
        },
        isAutoplay: autoBetStore.isAutoBetOn,
      };
      mainGameConnection.doSpin(model);
      minesBetStore.setIsBetsClosed(true);
    }
  }

  handleDoSpinResult({ responseCode, odds, balance }) {
    if (responseCode === ValidationType.Success) {
      if (userSettingsStore.isSoundOn) {
        soundService.play(MinesSoundsName.bet);
      }
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      minesBetStore.setIsDoSpinStart(true);
      minesBetStore.setCashOutWin(0);
      minesBetStore.setOddsByBombCount(odds);
      minesBetStore.setIsAllowSendResultReport(true);
      if (autoBetStore.isAutoBetOn && autoBetStore.autoBetCount) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
        autoBetStore.setIsAutoBetStart(true);
        this.autoBet();
      }
    } else {
      minesBetStore.setIsBetsClosed(false);
      notificationStore.setNotification(responseCode);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
    }
  }

  autoBet() {
    minesBetStore.setIsBetsClosed(true);
    this.sendResultReport(minesBetStore.selectedFieldsIndex);
    minesBetStore.setIsAllowSendResultReport(false);
  }

  randomGenerateField = () => {
    const randomIndex = Math.floor(Math.random() * minesBetStore.nonSelectedBoxIndex.length);
    const fieldIndex = minesBetStore.nonSelectedBoxIndex[randomIndex];
    this.sendResultReport([fieldIndex]);
  };

  sendResultReport(fieldIndexArr) {
    if (
      !minesBetStore.minesBox[fieldIndexArr]?.result &&
      !minesBetStore.isLose &&
      minesBetStore.isAllowSendResultReport
    ) {
      minesBetStore.setIsAllowSendResultReport(false);
      minesGameConnection.sendResultReport(fieldIndexArr);
    }
  }

  handleReportStateResult({
    mineFieldStates,
    responseCode,
    winAmount,
    odd,
    additionalInfo,
    freebetInfo,
    hash,
    key,
    salt,
    spinId,
    status,
  }) {
    if (responseCode === ValidationType.Success) {
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      minesBetStore.setCurrentActiveOdd(odd);
      minesBetStore.setIsBetsClosed(false);
      minesBetStore.setMinesBox(mineFieldStates);
      minesBetStore.setCashOutWin(winAmount);
      if (!autoBetStore.isAutoBetStart) {
        minesBetStore.setIsAllowSendResultReport(true);
      }

      minesBetStore.setNonSelectedBoxIndex(mineFieldStates);
      if (status === MinesBetStatus.lose) {
        if (userSettingsStore.isSoundOn) {
          soundService.play(MinesSoundsName.bomb);
        }
        minesBetStore.setIsLose(true);
        checkHashStore.setLastRoundInfo({ salt, key, hash });
        checkHashStore.setNextRoundHash(additionalInfo.hash);
        checkHashStore.setLastRoundResult({
          mineFieldStates,
          id: spinId,
          bombCount: additionalInfo.bombCount,
        });
        clearTimeout(resetTimeOutId);
        resetTimeOutId = setTimeout(() => {
          minesBetStore.setOpenedFields([]);
          this.resetGameState();
        }, 1500);
      } else if (status === MinesBetStatus.onHold) {
        minesBetStore.setIsAllowCashOut(true);
        if (isFirstMinesSound) {
          if (userSettingsStore.isSoundOn) {
            soundService.play(MinesSoundsName.diamond1);
          }
          isFirstMinesSound = !isFirstMinesSound;
        } else {
          if (userSettingsStore.isSoundOn) {
            soundService.play(MinesSoundsName.diamond2);
          }
          isFirstMinesSound = !isFirstMinesSound;
        }
        minesBetStore.updateDiamondsCount();
        minesBetStore.updateOddsForView(odd);
      } else {
        this.handleWinState({
          winAmount,
          odd,
          salt,
          key,
          hash,
          additionalInfo,
          mineFieldStates,
          spinId,
        });
      }

      if (autoBetStore.isAutoBetStart) {
        checkHashStore.setLastRoundInfo({ salt, key, hash });
        checkHashStore.setNextRoundHash(additionalInfo.hash);
        checkHashStore.setLastRoundResult({
          mineFieldStates,
          id: spinId,
          bombCount: additionalInfo.bombCount,
        });
      }
    } else {
      minesBetStore.setOpenedFields([]);
      notificationStore.setNotification(responseCode);
    }
  }

  sendCashOut() {
    if (minesBetStore.isAllowCashOut) {
      minesBetStore.setIsAllowCashOut(false);
      minesGameConnection.sendCashOut();
      clearTimeout(autoSelectTimeOutId);
    }
  }

  handleWinBet({ winAmount, odd }) {
    if (userSettingsStore.isSoundOn) {
      soundService.play(MinesSoundsName.win);
    }
    minesBetStore.setWinAmount(winAmount);
    minesBetStore.setWinOdd(odd);
    clearTimeout(resetTimeOutId);
    resetTimeOutId = setTimeout(() => {
      this.resetGameState();
    }, 1500);
  }

  handleWinState({ winAmount, odd, salt, key, hash, additionalInfo, mineFieldStates, spinId }) {
    this.handleWinBet({ winAmount, odd });
    minesBetStore.setOpenedFields([]);
    checkHashStore.setLastRoundInfo({ salt, key, hash });
    checkHashStore.setNextRoundHash(additionalInfo.hash);
    checkHashStore.setLastRoundResult({
      mineFieldStates,
      id: spinId,
      bombCount: additionalInfo.bombCount,
    });
  }

  handleCashOutResult({
    winAmount,
    responseCode,
    odd,
    mineFieldStates,
    key,
    salt,
    freebetInfo,
    hash,
    additionalInfo,
    spinId,
  }) {
    if (responseCode === ValidationType.Success) {
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      this.handleWinState({
        winAmount,
        odd,
        salt,
        key,
        hash,
        additionalInfo,
        mineFieldStates,
        spinId,
      });
    } else {
      notificationStore.setNotification(responseCode);
    }
  }

  sendChangeBombCount(bombCount) {
    minesGameConnection.sendChangeBombCount({ bombCount });
  }

  handleChangeBombCountResult({ hash, additionalData }) {
    minesBetStore.setOdds(additionalData.odds);
    checkHashStore.setNextRoundHash(hash);
  }

  resetGameState() {
    minesBetStore.setIsDoSpinStart(false);
    minesBetStore.setMinesBox(new Array(MAX_BOX_COUNT).fill(MINES_FIELD_STATE.UnOpened));
    minesBetStore.setCashOutWin(null);
    minesBetStore.setDiamondsCount(MAX_BOX_COUNT - minesBetStore.minesCount);
    minesBetStore.setIsAllowCashOut(false);
    minesBetStore.setIsBetsClosed(false);
    minesBetStore.setWinAmount(null);
    minesBetStore.setWinOdd(null);
    minesBetStore.setIsLose(false);
    minesBetStore.setActiveOdd(null);
    minesBetStore.resetNonSelectedBoxIndex();
    minesBetStore.setOddsByBombCount([]);
    minesBetStore.setOddsForView([]);
    betHistoryStore.getLastBet();
    userInfoStore.getBalance();
    if (autoBetStore.autoBetCount && autoBetStore.isAutoBetOn) {
      this.doSpin();
    }
    if (!autoBetStore.autoBetCount && autoBetStore.isAutoBetOn && autoBetStore.isAutoBetStart) {
      this.resetAutoBetState();
    }
  }

  resetAutoBetState() {
    autoBetStore.setIsAutoBetStart(false);
    autoBetStore.setIsAutoBetOn(false);
    autoBetStore.setAutoBetCount(DEFAULT_AUTO_BET_COUNT);
    this.resetGameState();
  }

  clearTimeOutIds() {
    clearTimeout(autoSelectTimeOutId);
    clearTimeout(resetTimeOutId);
  }
}

export const minesGameService = new MinesGameService();
